import { IconMenuButton } from '@driftt/dds'
import React from 'react'

export default function ActionMenu({ actions }) {
  const options = actions.map(({ fn, disabled, label }) => ({
    action: fn,
    name: label,
    disabled,
  }))

  return (
    <IconMenuButton iconVariant="spillover" options={options} title="Actions" />
  )
}
